import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Home } from 'lucide-react';
import { PageSEO } from '@/components/SEO';

export default function Takk() {
  useEffect(() => {
    // Google Ads Conversion tracking
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18011833984/9TkVCN-E5YscEICN24xD'
      });
      // Skjema for potensielle salg sendt inn (konto AW-18257792702)
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18257792702/DOkzCLe94sIcEL6d_4FE',
        'value': 1.0,
        'currency': 'NOK'
      });
    }
  }, []);

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-muted/30">
      <PageSEO 
        title="Takk for din henvendelse" 
        path="/takk" 
        description="Vi har mottatt din melding og vil ta kontakt så snart som mulig."
      />
      <div className="max-w-2xl w-full px-6 py-16 text-center">
        <div className="w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-8">
          <CheckCircle className="w-10 h-10 text-accent" />
        </div>
        
        <h1 className="font-syne font-bold text-4xl md:text-5xl text-primary tracking-tight mb-6">
          Takk for din henvendelse!
        </h1>
        
        <p className="font-manrope text-lg text-muted-foreground mb-12 leading-relaxed">
          Vi har mottatt meldingen din. En av våre rådgivere vil gå gjennom informasjonen 
          og ta kontakt med deg innen 24 timer (man-fre) for en hyggelig samtale om ditt prosjekt.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-syne font-bold text-sm uppercase tracking-wide px-8 py-4 bg-primary text-primary-foreground hover:bg-accent transition-colors duration-300 group"
          >
            <Home className="w-4 h-4" />
            Tilbake til forsiden
          </Link>
          <Link
            to="/prosjekter"
            className="inline-flex items-center gap-2 font-syne font-bold text-sm uppercase tracking-wide px-8 py-4 border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300 group"
          >
            Se våre prosjekter
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </div>
  );
}
